<template>

<div class="toggle" v-if="optionsFinal.length > 1">

    <div class="toggle-item" v-for="option in optionsFinal" :class="{'is-active': option.value === model}" :key="option.value" v-on:click="onClick(option.value)">

        {{ option.text }}

    </div>

</div>

</template>

<script>

export default {

    props: ['value', 'type', 'rule'],

    data: function() {

        return {
            model: ''
        }

    },

    created: function() {

        this.model = this.value

    },

    computed: {

        optionsFinal: function() {

            var options = []

            this.$_.each(this.type.options, function(text, value) {

                options.push({
                    value: value,
                    text: text
                })

            })

            return options

        }

    },

    watch: {

        value: function(n) {

            this.model = n

        },

        model: function(n) {

            this.$emit('input', n)

        }

    },

    methods: {
        
        onClick: function(value) {

            this.$emit('input', value)

        }

    }

}

</script>

<style scoped>

.toggle {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
    grid-gap: 4px;
    width: 100%;
}

.toggle-item {
    padding: 8px 10px;
    line-height: 18px;
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    user-select: none;
    border-radius: 4px;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.15);
    text-align: center;
}

.is-desktop .toggle-item:not(.is-active):hover {
    background-color: rgba(0, 0, 0, 0.25);
}

.toggle-item.is-active {
    background-color: #4881bb;
}

</style>